import { OneFriendIcon } from '../../icons/OneFriendIcon'
import { Label } from '../Label'
import { StarAnim } from '../StarAnim'

import styles from './Condition1Art.module.scss'

type Props = {
    label: string
}

export const Condition1Art = ({ label }: Props) => (
    <div className={styles.container}>
        <div className={styles.iconWrap}>
            <OneFriendIcon />
        </div>
        <Label label={label} />
        <div className={styles.starAnimWrap}>
            <StarAnim width={140} height={140} className={styles.starAnim} />
        </div>
    </div>
)
